import React from 'react';
import PropTypes from 'prop-types';
// Explicit React import required: Babel preset React is configured with runtime "classic"
import { useSelector } from 'react-redux';
import {
  unstable_HistoryRouter as Router,
  Route,
  Routes,
} from 'react-router-dom';
import Base from './components/layouts/PageBase/Base';
import AppContextProvider from './contexts';
import pages from './pages';
import '@mantine/core/styles.css';
import '@mantine/dates/styles.css';
import { router } from './utils/routeBuilder';
import { checkExpireTime, clearStorages, getToken } from './utils/storage';
import 'dayjs/locale/id';

const noAuthRoutes = [
  '/login',
  '/forgot-password',
  '/set-password',
  '/404',
  '/mfa/scan-qr',
  '/setup-authenticator',
];
const assets = ['/assets', '/assets/:id'];

if (!window.location.pathname.startsWith('/dc')) {
  window.location.replace(getToken() ? '/dc/authentication' : '/dc/login');
}

const noAuth = RegExp(noAuthRoutes.join('|')).exec(window.location.pathname);
const token = getToken();

if (!token && !noAuth) {
  sessionStorage.setItem('redirect', window.location.pathname);
  window.location.replace('/dc/login');
} else if (checkExpireTime() && !noAuth) {
  clearStorages();
  window.location.replace('/dc/login');
} else if (getToken() && noAuth) {
  window.location.replace('/dc/authentication');
}

if (assets.includes(window.location.pathname)) {
  window.location.replace('/404');
}

const App = ({ history }) => {
  const _hardCodedSubMerchant = [
    {
      permitionId: 'id-1',
      roleId: '4237fe34-590d-4381-ad85-292eb72e31fd',
      name: 'Data Monitoring',
      path: '/sub-merchant/data-monitoring',
    },
    {
      permitionId: 'id-2',
      roleId: '4237fe34-590d-4381-ad85-292eb72e31fd',
      name: 'Data Subpangkalan LPG 3Kg',
      path: '/sub-merchant/setting-data-sub-merchant/search',
    },
    {
      permitionId: 'id-3',
      roleId: '4237fe34-590d-4381-ad85-292eb72e31fd',
      name: 'Data Subpangkalan LPG 3Kg',
      path: '/sub-merchant/setting-data-sub-merchant/detail/:id',
    },
  ];

  const permissions = useSelector((state) =>
    state.pageBase.dataDetailUser.permitions?.concat?.(_hardCodedSubMerchant)
  );

  return (
    <Router basename="/dc" history={history}>
      <AppContextProvider>
        <Base>
          {/* <PageBase> */}
          <Routes>
            <Route element={<pages.Login />} path="/login" />
            <Route element={<pages.ForgotPassword />} path="/forgot-password" />
            <Route element={<pages.ResetPassword />} path="/set-password" />
            <Route
              element={<pages.SetupAuthenticator />}
              path="/setup-authenticator"
            />
            <Route element={<pages.ScanCodeMFA />} path="/mfa/scan-qr" />
            <Route element={<pages.MfaConnectApp />} path="/mfa/connect-app" />
            <Route element={<pages.Mfa />} path="/mfa/totp" />
            <Route element={<pages.Authentication />} path="/" />
            <Route element={<pages.Authentication />} path="/authentication" />
            <Route element={<pages.Profile />} path="/profile" />
            <Route element={<pages.Error404 />} path={'/404'} />
            <Route
              element={<pages.TermConditionPreview />}
              path="/term-condition/preview/:type"
            />
            <Route element={<pages.NikManagement />} path="/customer-setting" />
            <Route
              element={<pages.DetailCustomer />}
              path="/customer-setting/detail/:id"
            />
            <Route
              element={<pages.BlockedCustomer />}
              path="/customer-setting/nik-blocked/:id"
            />
            <Route
              element={<pages.NikBlockedBulk />}
              path="/customer-setting/nik-blocked-bulk"
            />
            <Route
              element={<pages.NikActivateBulk />}
              path="/customer-setting/nik-activate-bulk"
            />
            <Route
              element={<pages.NikLogStatus />}
              path="/customer-setting/status/:id"
            />
            <Route
              element={<pages.CustomerSubmissionUnblock />}
              path="/customer-submission-unblock"
            />
            <Route
              element={<pages.CustomerSubmissionUnblockDetail />}
              path="/customer-submission-unblock/detail/:id"
            />
            {router.map((route) =>
              permissions.map((permission) =>
                route.path === permission.path
                  ? route.elements.map((element) => (
                    <Route
                      element={
                        element.disabled ? (
                          <pages.Error403 />
                        ) : (
                          element.element
                        )
                      }
                      key={permission.permissionId + element.path}
                      path={element.path}
                    />
                  ))
                  : []
              )
            )}
            <Route element={<pages.Error404 />} path="*" />
          </Routes>
          {/* </PageBase> */}
        </Base>
      </AppContextProvider>
    </Router>
  );
};

// Remove: export default hot(App);
// React Fast Refresh handles HMR automatically
export default App;

App.propTypes = {
  history: PropTypes.object.isRequired,
  store: PropTypes.object.isRequired,
};
